module.exports = __webpack_public_path__ + "img/ch-assistance.7fe655dd.jpg";